"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _memberManagement = require("@/api/member/memberManagement");
var _index = require("@/utils/index");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'AccountChangeDetail',
  props: {
    memberData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      // 会员账户信息
      availableBalance: 0,
      consumptionPoints: 0,
      // 搜索表单
      searchForm: {
        accountType: 'asset',
        // 默认资产变动
        changeType: '',
        timeRange: [],
        userId: null,
        // 用户ID，用于筛选该会员的记录
        cardNo: null // 卡号，用于积分接口
      },
      // 表格数据
      tableData: [],
      // 加载状态
      loading: false,
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    // 获取账户变动明细列表
    fetchAccountLogList: function () {
      var _fetchAccountLogList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, response, data, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              _context.prev = 1;
              if (this.searchForm.userId) {
                _context.next = 2;
                break;
              }
              this.$message.warning('缺少用户ID，无法获取账户明细');
              this.loading = false;
              return _context.abrupt("return");
            case 2:
              params = _objectSpread({
                page: this.currentPage,
                // 当前页码
                limit: this.pageSize,
                // 每页条数
                userId: this.searchForm.userId
              }, this.searchForm); // 如果是积分账户类型且有卡号，添加卡号参数
              if (this.searchForm.accountType === 'points' && this.searchForm.cardNo) {
                params.cardNo = this.searchForm.cardNo;
              }

              // 如果是积分账户，将changeType映射为transOrigin
              if (this.searchForm.accountType === 'points' && this.searchForm.changeType !== '') {
                params.transOrigin = this.searchForm.changeType;
                delete params.changeType;
              }

              // 处理时间范围数据
              if (this.searchForm.timeRange && this.searchForm.timeRange.length === 2) {
                params.startTime = this.searchForm.timeRange[0];
                params.endTime = this.searchForm.timeRange[1];
              }
              // 删除timeRange字段，因为后端不需要这个字段
              delete params.timeRange;

              // 过滤空值参数（但保留userId和cardNo）
              Object.keys(params).forEach(function (key) {
                if (!['userId', 'cardNo'].includes(key) && (params[key] === '' || params[key] === null || params[key] === undefined)) {
                  delete params[key];
                }
              });
              if (!(this.searchForm.accountType === 'points')) {
                _context.next = 4;
                break;
              }
              _context.next = 3;
              return (0, _memberManagement.xyBonusLogPage)(params);
            case 3:
              response = _context.sent;
              _context.next = 6;
              break;
            case 4:
              _context.next = 5;
              return (0, _memberManagement.xyUserAccountLogPage)(params);
            case 5:
              response = _context.sent;
            case 6:
              if (response.code === 200) {
                if (this.searchForm.accountType === 'points') {
                  // 积分账户接口返回结构：{ data: { TotalCount, Trans: [{transVal, relationName, transDate}] } }
                  data = response.data || {};
                  this.tableData = data.Trans || [];
                  this.total = parseInt(data.TotalCount) || 0;
                } else {
                  this.tableData = response.records || [];
                  this.total = response.total || 0;
                }
              } else {
                this.$message.error(response.message || '获取账户变动明细失败');
              }
              _context.next = 8;
              break;
            case 7:
              _context.prev = 7;
              _t = _context["catch"](1);
              this.$message.error('获取账户变动明细失败');
            case 8:
              _context.prev = 8;
              this.loading = false;
              return _context.finish(8);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 7, 8, 9]]);
      }));
      function fetchAccountLogList() {
        return _fetchAccountLogList.apply(this, arguments);
      }
      return fetchAccountLogList;
    }(),
    // 格式化货币显示
    formatCurrency: function formatCurrency(amount) {
      return "".concat(amount.toFixed(2), "\u5143");
    },
    // 搜索功能
    handleSearch: function handleSearch() {
      this.currentPage = 1;
      this.fetchAccountLogList();
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchAccountLogList();
    },
    // 当前页改变
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchAccountLogList();
    },
    // 格式化时间
    formatTime: function formatTime(time) {
      if (!time) return '';
      return (0, _index.parseTime)(time, '{y}-{m}-{d} {h}:{i}:{s}');
    },
    // 格式化金额变动
    formatAmountChange: function formatAmountChange(amount) {
      if (!amount && amount !== 0) return '0.00';
      var num = parseFloat(amount);
      if (num > 0) {
        return "+".concat(num.toFixed(2));
      } else if (num < 0) {
        return num.toFixed(2);
      } else {
        return '0.00';
      }
    },
    // 格式化积分变化
    formatPointsChange: function formatPointsChange(points) {
      if (!points && points !== 0) return '0';
      var num = parseInt(points);
      if (num > 0) {
        return "+".concat(num);
      } else if (num < 0) {
        return num.toString();
      } else {
        return '0';
      }
    },
    // 获取变动类型文本
    getChangeTypeText: function getChangeTypeText(type) {
      var typeMap = {
        0: '充值',
        1: '退款',
        2: '订单消费',
        3: '订单取消',
        4: '订单退款',
        5: '转账扣减',
        6: '调账加减',
        8: '转账扣减',
        9: '调账加减'
      };
      return typeMap[type] || '未知类型';
    },
    // 获取积分变更来源文本
    getTransOriginText: function getTransOriginText(transOrigin) {
      var originMap = {
        0: '活动奖励',
        1: '天财推送'
      };
      return originMap[transOrigin] || '未知来源';
    },
    // 获取积分状态文本
    getBonusStatusText: function getBonusStatusText(status) {
      var statusMap = {
        1: '待处理',
        2: '处理中',
        3: '已完成',
        4: '已失败'
      };
      return statusMap[status] || '未知状态';
    },
    // 获取金额样式类
    getAmountClass: function getAmountClass(amount) {
      if (!amount && amount !== 0) return 'amount-cell zero';
      var num = parseFloat(amount);
      if (num > 0) {
        return 'amount-cell positive';
      } else if (num < 0) {
        return 'amount-cell negative';
      } else {
        return 'amount-cell zero';
      }
    },
    // 获取状态样式类
    getStatusClass: function getStatusClass(status) {
      var classMap = {
        1: 'status-tag pending',
        2: 'status-tag processing',
        3: 'status-tag success',
        4: 'status-tag failed'
      };
      return classMap[status] || 'status-tag';
    }
  },
  watch: {
    // 监听账户类型变化，自动重新获取数据
    'searchForm.accountType': function searchFormAccountType(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.fetchAccountLogList();
      }
    },
    // 监听memberData变化，确保userId和cardNo始终正确
    'memberData.userId': {
      handler: function handler(newUserId) {
        if (newUserId) {
          this.searchForm.userId = newUserId;
          // 如果userId发生变化，重新获取数据
          this.currentPage = 1;
          this.fetchAccountLogList();
        }
      },
      immediate: true
    },
    // 监听卡号变化
    'memberData.cardNo': {
      handler: function handler(newCardNo) {
        if (newCardNo) {
          this.searchForm.cardNo = newCardNo;
        }
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    // 设置用户ID和卡号用于筛选
    if (this.memberData && this.memberData.userId) {
      this.searchForm.userId = this.memberData.userId;
      this.searchForm.cardNo = this.memberData.cardNo; // 设置卡号
      // 更新会员账户信息显示
      this.availableBalance = this.memberData.money || 0;
      this.consumptionPoints = this.memberData.bonus || 0;
    } else {
      console.warn('未接收到有效的memberData或userId');
    }
    // 初始化时获取账户变动明细数据
    this.fetchAccountLogList();
  }
};